import { client } from '@core/api/API'

export default {
  async fetchEquipmentTypes() {
    return await client.get('/equipment-types')
  },

  /**
   * @param {{
   *  numberOfPlants?: number,
   *  equipmentTypeId?: string,
   *  category?: string,
   *  brand?: string,
   *  search?: string,
   *  page?: number,
   *  limit?: number,
   * }} params
   * @returns {Promise<{ items: any[], total: number }>}
   */
  async fetchEquipmentItems(params) {
    const response = await client.get('/equipment-items', {
      params,
    })

    return response.data
  },

  /**
   * @param {{
   *   numberOfPlants?: number,
   *   budget?: string,
   *   location?: string,
   * }} params
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchEquipmentShoppingList(params) {
    return client.get('/equipment-shopping-lists', {
      params,
    })
  },

  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchBrands() {
    return await client.get('/equipment-items/brands')
  },

  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchNumberOfPlants() {
    return await client.get('/equipment-items/number-of-plants')
  },

  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchEquipmentCategories() {
    return await client.get('/equipment-items/categories')
      .then(res => res.data)
  },

  async createCustomEquipmentItem(item) {
    return client.post('/equipment-items/custom', item)
      .then(res => res.data)
  },

  async fetchEquipmentRetailers() {
    return client.get('/equipment-items/retailers')
      .then(res => res.data)
  },
}
